import { Button } from '@chakra-ui/react';
import Link from 'next/link';

export function TopCTA({ applyURL }: { applyURL: string }) {
  return (
    <div className="text-center">
      <h1 className="text-5xl font-extrabold tracking-tight text-gray-900 md:text-6xl">
        <span className="inline">Clerk for</span>{' '}
        <span className="inline text-clerk-blue">Startups</span>
      </h1>
      <p className="mx-auto mt-3 max-w-md text-base text-gray-500 sm:text-lg md:mt-5 md:max-w-3xl md:text-xl">
        Launch your application with beautiful user management features.
        <br />
      </p>
      <p className="mx-auto mt-3 max-w-md text-base text-gray-500 sm:text-lg md:mt-5 md:max-w-3xl md:text-xl">
        Save <strong>time</strong> and <strong>money</strong> with up to 6
        months free.
      </p>
      <div className="mx-auto mt-5 max-w-md sm:flex sm:justify-center md:mt-8">
        <div className="rounded-md">
          <Link href={applyURL} target="_blank" rel="noopener">
            <Button variant="base" minW="225px" h="48px" fontSize={'md'}>
              Apply Now
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
